export interface Cords {
  x: number;
  y: number;
}

export enum Anchor {
  topLeft = 'top-left',
  topMiddle = 'top-middle',
  topRight = 'top-right',
  middleLeft = 'middle-left',
  middle = 'middle',
  middleRight = 'middle-right',
  bottomLeft = 'bottom-left',
  bottomMiddle = 'bottom-middle',
  bottomRight = 'bottom-right',
}

export interface HorizontalAnchors {
  left: Cords;
  middle: Cords;
  right: Cords;
}

export interface VerticalAnchors {
  top: HorizontalAnchors;
  middle: HorizontalAnchors;
  bottom: HorizontalAnchors;
}

export class Anchors {
  private anchors: VerticalAnchors;

  public readonly width: number = 0;
  public readonly height: number = 0;

  constructor(el: HTMLElement) {
    const rect = el.getBoundingClientRect();

    const nativeLeft = rect.left;
    const nativeTop = rect.top;

    const left = nativeLeft;
    const horizontalMiddle = nativeLeft + (rect.width / 2);
    const right = nativeLeft + rect.width;

    const top = nativeTop;
    const verticalMiddle = nativeTop + (rect.height / 2);
    const bottom = nativeTop + rect.height;

    this.width = rect.width;
    this.height = rect.height;

    this.anchors = {
      top: {
        left: {
          x: left,
          y: top,
        },
        middle: {
          x: horizontalMiddle,
          y: top,
        },
        right: {
          x: right,
          y: top,
        },
      },
      middle: {
        left: {
          x: left,
          y: verticalMiddle,
        },
        middle: {
          x: horizontalMiddle,
          y: verticalMiddle,
        },
        right: {
          x: right,
          y: verticalMiddle,
        },
      },
      bottom: {
        left: {
          x: left,
          y: bottom,
        },
        middle: {
          x: horizontalMiddle,
          y: bottom,
        },
        right: {
          x: right,
          y: bottom,
        },
      },
    };
  }

  getByAnchor(anchor: Anchor): Cords {
    const map = {
      [Anchor.topLeft]: this.anchors.top.left,
      [Anchor.topMiddle]: this.anchors.top.middle,
      [Anchor.topRight]: this.anchors.top.right,
      [Anchor.middleLeft]: this.anchors.middle.left,
      [Anchor.middle]: this.anchors.middle.middle,
      [Anchor.middleRight]: this.anchors.middle.right,
      [Anchor.bottomLeft]: this.anchors.bottom.left,
      [Anchor.bottomMiddle]: this.anchors.bottom.middle,
      [Anchor.bottomRight]: this.anchors.bottom.right,
    };

    return map[anchor] ?? map[Anchor.bottomLeft];
  }
}